<app-mat-spinner-overlay *ngIf="showWaitingForDataSpinner != 0" [overlay]="true">
</app-mat-spinner-overlay>

<mat-expansion-panel [(expanded)]="expanded">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <b>{{ betrieb?.bezeichnung?.trim() || 'Unbekannter Betrieb' }}</b>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <mat-card>
    <div class="row-zweispaltig">
      <div class="column-zweispaltig-klein">Grundlage der Klassifizierung:</div>

      <div class="column-zweispaltig-gross">
        Durchführungsverordnung (EU) 2019/1975 der Kommission vom 31. Oktober
        2019
      </div>
    </div>

    <div class="row-zweispaltig">
      <div class="column-zweispaltig-klein">
        Klassifizierung durchgeführt am:
      </div>

      <div class="column-zweispaltig-gross">
        {{ currentDate | date : "dd.MM.yyyy" }}
      </div>
    </div>

    <div class="row-zweispaltig">
      <div class="column-zweispaltig-klein">Region:</div>

      <div class="column-zweispaltig-gross">
        {{ betrieb.regionDe }}
      </div>
    </div>

    <div class="row-zweispaltig">
      <div class="column-zweispaltig-klein">
        Betriebsnummer oder Bezeichnung:
      </div>

      <div class="column-zweispaltig-gross">
        {{ betrieb.bezeichnung }}
      </div>
    </div>

    <div class="row-zweispaltig">
      <div class="column-zweispaltig-klein">Allgemeine-BWA:</div>

      <div class="column-zweispaltig-gross">
        <div class="row-zweispaltig">
          <div class="column-zweispaltig-klein">{{ betrieb.allgBwaNrDe }}</div>

          <div class="column-zweispaltig-gross">
            {{ betrieb.allgBwaNameDe }}
          </div>
        </div>
      </div>
    </div>

    <div class="row-zweispaltig">
      <div class="column-zweispaltig-klein">Haupt-BWA:</div>

      <div class="column-zweispaltig-gross">
        <div class="row-zweispaltig">
          <div class="column-zweispaltig-klein">{{ betrieb.hauptBwaNrDe }}</div>

          <div class="column-zweispaltig-gross">
            {{ betrieb.hauptBwaNameDe }}
          </div>
        </div>
      </div>
    </div>

    <div class="row-zweispaltig">
      <div class="column-zweispaltig-klein">BWA-Untergruppe:</div>

      <div class="column-zweispaltig-gross">
        <div class="row-zweispaltig">
          <div class="column-zweispaltig-klein">
            {{ betrieb.hauptBwaUGruppe }}
          </div>

          <div class="column-zweispaltig-gross">
            {{ betrieb.nameUntergruppe }}
          </div>
        </div>
      </div>
    </div>

    <div class="row-zweispaltig">
      <div class="column-zweispaltig-klein">Einzel-BWA:</div>

      <div class="column-zweispaltig-gross">
        <div class="row-zweispaltig">
          <div class="column-zweispaltig-klein">{{ betrieb.klasse }}</div>

          <div class="column-zweispaltig-gross">
            {{ betrieb.einzelBwaBeschreibung }}
          </div>
        </div>
      </div>
    </div>

    <div class="row-zweispaltig">
      <div class="column-zweispaltig-klein">
        Wirtschaftliche Betriebsgröße (Gesamt-SO):
      </div>

      <div class="column-zweispaltig-gross">
        {{ betrieb.soBetrieb | number : "0.0-0" : "de-DE" }} €
      </div>
    </div>

    <div class="row-zweispaltig">
      <div class="column-zweispaltig-klein">Größenklasse:</div>

      <div class="column-zweispaltig-gross">
        {{ betrieb.bglKlasse }} ({{ betrieb.von | number : "0.0-0" : "de-DE" }} € -
        {{ betrieb.bis | number : "0.0-0" : "de-DE" }} €)
      </div>
    </div>

    <div class="spacer"></div>
    <div class="col-md-12">
      <mat-expansion-panel [expanded]="false">
        <mat-expansion-panel-header>
          <mat-panel-title><b>Ermittlung der wirtschaftlichen Betriebsgröße (Gesamt-SO)</b></mat-panel-title>
        </mat-expansion-panel-header>

        <table mat-table [dataSource]="dataBetriebsgroesse" class="table-breite-komplett">
          <ng-container matColumnDef="SOC_CODE">
            <th *matHeaderCellDef class="mat-column-header-soc-code mat-column-header-first-entry">
              SOC-Code
            </th>
            <td mat-cell *matCellDef="let entry" class="mat-column-cell-soc-code mat-column-cell-first-entry">
              {{ entry.socCode }}
            </td>
            <td mat-footer-cell *matFooterCellDef class="mat-column-cell-soc-code mat-column-cell-first-entry-no-base">
              <b>Gesamt-SO</b>
            </td>
          </ng-container>

          <ng-container matColumnDef="SOC_MERKMAL">
            <th *matHeaderCellDef class="mat-column-header-soc-merkmal mat-column-header">
              Merkmal
            </th>
            <td mat-cell *matCellDef="let entry" class="mat-column-cell-soc-merkmal mat-column-cell">
              {{ entry.socName }}
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
          <ng-container matColumnDef="MENGE">
            <th *matHeaderCellDef class="mat-column-header-MENGE mat-column-header" [ngStyle]="{'display': 'none'}">
              Menge
            </th>
            <td mat-cell *matCellDef="let entry" class="mat-column-cell-menge mat-column-cell mat-column-cell-right">
              {{ entry.menge | number : "0.2-2" : "de-DE" }}
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>
          <ng-container matColumnDef="MENGEEINHEIT">
            <th *matHeaderCellDef class="mat-column-header-mengeeinheit mat-column-header" [attr.colspan]="2">
              Produktionsumfang
            </th>
            <td mat-cell *matCellDef="let entry" class="mat-column-cell-mengeeinheit mat-column-cell">
              {{ entry.mengeeinheit }}
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <ng-container matColumnDef="SO_KOEFFIZIENT">
            <th *matHeaderCellDef class="mat-column-header-so-koeffizient mat-column-header" [attr.colspan]="2">
              SOC
            </th>
            <td mat-cell *matCellDef="let entry"
              class="mat-column-cell-so-koeffizient mat-column-cell mat-column-cell-right">
              {{ entry.koeffizient | number : "0.0-0" : "de-DE" }}
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <ng-container matColumnDef="BEZUGSEINHEIT">
            <th *matHeaderCellDef class="mat-column-header-bezugseinheit mat-column-header"
              [ngStyle]="{'display': 'none'}">
              Bezugseinheit
            </th>
            <td mat-cell *matCellDef="let entry" class="mat-column-cell-bezugseinheit mat-column-cell">
              {{ entry.bezugseinheit }}
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <ng-container matColumnDef="SO_BETRAG">
            <th *matHeaderCellDef class="mat-column-header-so-betrag mat-column-header">
              SO-Betrag [€]
            </th>
            <td mat-cell *matCellDef="let entry"
              class="mat-column-cell-so-betrag mat-column-cell mat-column-cell-right">
              {{ entry.soBetrag | number : "0.0-0" : "de-DE" }}
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <ng-container matColumnDef="SALDO">
            <th *matHeaderCellDef class="mat-column-header-saldo mat-column-header">
              Saldo [€]
            </th>
            <td mat-cell *matCellDef="let entry" class="mat-column-cell-saldo mat-column-cell mat-column-cell-right">
              {{ entry.saldo | number : "0.0-0" : "de-DE" }}
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <ng-container matColumnDef="SO_BETRAG_BEREINIGT">
            <th *matHeaderCellDef class="mat-column-header-so-bereinigt mat-column-header">
              SO-Betrag bereinigt [€]
            </th>
            <td mat-cell *matCellDef="let entry"
              class="mat-column-cell-so-bereinigt mat-column-cell mat-column-cell-right">
              {{ entry.soBetragBtr | number : "0.0-0" : "de-DE" }}
            </td>
            <td mat-footer-cell *matFooterCellDef
              class="mat-column-cell-so-bereinigt mat-column-cell-no-base mat-column-cell-right">
              <b> {{ betrieb.gesamtSoBetragBtr | number : "0.0-0" : "de-DE" }} </b>
            </td>
          </ng-container>

          <ng-container matColumnDef="BEMERKUNG">
            <th *matHeaderCellDef class="mat-column-header-soc-name mat-column-header">
              Sonderfall/Umrechnung
            </th>
            <td mat-cell *matCellDef="let entry" class="mat-column-column-soc-name mat-column-cell">
              {{ entry.sonderfall }}
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColsBetriebsgroesse"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColsBetriebsgroesse"></tr>
          <tr mat-footer-row *matFooterRowDef="displayedColsBetriebsgroesse"></tr>
        </table>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="false">
        <mat-expansion-panel-header>
          <mat-panel-title><b>Ermittlung der betriebswirtschaftlichen Ausrichtung</b></mat-panel-title>
        </mat-expansion-panel-header>

        <table mat-table [dataSource]="dataSocMerkmale" class="table-breite-komplett">
          <ng-container matColumnDef="SOC_CODE">
            <th *matHeaderCellDef class="mat-column-header-soc-code mat-column-header-first-entry">
              Code
            </th>
            <td mat-cell *matCellDef="let entry" class="mat-column-cell-soc-name mat-column-cell-first-entry">
              {{ entry.socCode }}
            </td>
          </ng-container>

          <ng-container matColumnDef="SOC_MERKMAL">
            <th *matHeaderCellDef class="mat-column-header-code-bezeichnung mat-column-header">
              Code-Bezeichnung
            </th>
            <td mat-cell *matCellDef="let entry" class="mat-column-column-code-bezeichnung mat-column-cell">
              {{ entry.socName }}
            </td>
          </ng-container>

          <ng-container matColumnDef="SO_BETRAG">
            <th *matHeaderCellDef class="mat-column-header-so-betrag mat-column-header">
              SO-Betrag [€]
            </th>
            <td mat-cell *matCellDef="let entry"
              class="mat-column-cell-so-betrag mat-column-cell mat-column-cell-right">
              {{ entry.soBetrag | number : "0.0-0" : "de-DE" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="BEMERKUNG">
            <th *matHeaderCellDef class="mat-column-header-soc-name mat-column-header">
              Sonderfall/Umrechnung
            </th>
            <td mat-cell *matCellDef="let entry" class="mat-column-column-soc-name mat-column-cell">
              {{ entry.bemerkung }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColsSocMerkmale"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColsSocMerkmale"></tr>
        </table>
      </mat-expansion-panel>

      <!--
      <mat-expansion-panel [expanded]="false">
        <mat-expansion-panel-header>
          <mat-panel-title><b>Diagramme</b>
            
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-card>
          <div class="row-zweispaltig"> 
      
    <app-anteile-so-chart class="column-zweispaltig-klein seite-an-seite-padding-right"  [betrieb]="betrieb"></app-anteile-so-chart>
 
           
              <app-sonderfaelle-chart
              class="column-zweispaltig-gross seite-an-seite-padding-right"
                [betrieb]="betrieb"
              ></app-sonderfaelle-chart>  

   
           
          </div>
        </mat-card>
      </mat-expansion-panel>
      -->
    </div>
    <div class="spacer"></div>
    <div class="col-md-12 min-heigh-for-button-card">
      <button (click)="onClickDownloadKlassifizierung()" mat-raised-button color="primary"
        class="button-margin-left custom-btn buttons-right" type="button">
        Download Klassifizierung (PDF)

        <fa-icon [icon]="faDownload" class="ml-1"></fa-icon>
      </button>
    </div>
    <!--
    <div class="col-md-12 min-heigh-for-button-card">
      <button
      (click)="onClickDownloadKlassifizierung()"
      mat-raised-button
      color="primary"
      class="custom-btn buttons-right"
      type="button"
    >
      Download Klassifizierung (Excel)

      <fa-icon [icon]="faDownload" class="ml-1"></fa-icon>
    </button>

    </div>
    -->
  </mat-card>
</mat-expansion-panel>